import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  id: '',
  showModal: false,
  userDetailsModal: false,
  videoConfirmModal: false,
  videoModal: false,
  planModal: false,
  memberPlanModal: false,
  viewPlayerPlanModal: false,
  agentPlanModal: false,
  viewAgentPlanModal: false,
  clubPlanModal: false,
  viewClubPlanModal: false,
  scoutPlanModal: false,
  viewScoutPlanModal: false,
  subscriptionModal: false,
  freeAccessModal: false,
  assignFreePlanModal: false,
  resendEmailModal: false,
  sendMessageModal: false,
  formDetails: {},
  files: [],
  selectedPage: 1
};

export const sharedSlice = createSlice({
  name: "sharedSlice",
  initialState: initialState,
  reducers: {
    setId: (state, { payload }) => {
      state.id = payload
    },
    setModalStatus: (state, { payload }) => {
      state.showModal = payload
    },
    setFormDetails: (state, { payload }) => {
      state.formDetails = payload
    },
    setVideoModal: (state, { payload }) => {
      state.videoModal = payload
    },
    setUserModalStatus: (state, { payload }) => {
      state.userDetailsModal = payload
    },
    setVideoConfirmModalStatus: (state, { payload }) => {
      state.videoConfirmModal = payload
    },
    setPlanModalStatus: (state, { payload }) => {
      state.planModal = payload;
    },
    setAgentModalStatus: (state, { payload }) => {
      state.agentPlanModal = payload;
    },
    setViewAgentPlanModalStatus: (state, { payload }) => {
      state.viewAgentPlanModal = payload;
    },
    setClubModalStatus: (state, { payload }) => {
      state.clubPlanModal = payload;
    },
    setViewClubPlanModalStatus: (state, { payload }) => {
      state.viewClubPlanModal = payload;
    },
    setScoutModalStatus: (state, { payload }) => {
      state.scoutPlanModal = payload;
    },
    setViewScoutModalStatus: (state, { payload }) => {
      state.viewScoutPlanModal = payload;
    },
    setSubscriptionModalStatus: (state, { payload }) => {
      state.subscriptionModal = payload;
    },
    setMemberPlanModalStatus: (state, { payload }) => {
      state.memberPlanModal = payload;
    },
    setViewPlayerPlanModalStatus: (state, { payload }) => {
      state.viewPlayerPlanModal = payload;
    },
    setFreeAccessModalStatus: (state, { payload }) => {
      state.freeAccessModal = payload;
    },
    setAssignFreePlanModalStatus: (state, { payload }) => {
      state.assignFreePlanModal = payload;
    },
    setResendEmailModalStatus: (state, { payload }) => {
      state.resendEmailModal = payload;
    },
    setSendMessageModalStatus: (state, { payload }) => {
      state.sendMessageModal = payload;
    },
    setFiles: (state, { payload }) => {
      state.files = payload.data
    },
    setPartnerProfileImages: (state, { payload }) => {
      state.formDetails.profilePicture = payload.data[0]?.url
    },
    setSelectedPage: (state, { payload }) => {
      state.selectedPage = payload
    },
  },
});

export const {
  setId,
  setModalStatus,
  setFormDetails,
  setVideoModal,
  setUserModalStatus,
  setFiles,
  setPartnerProfileImages,
  setVideoConfirmModalStatus,
  setSubscriptionModalStatus,
  setPlanModalStatus,
  setMemberPlanModalStatus,
  setViewPlayerPlanModalStatus,
  setFreeAccessModalStatus,
  setAssignFreePlanModalStatus,
  setSelectedPage,
  setAgentModalStatus,
  setViewAgentPlanModalStatus,
  setClubModalStatus,
  setViewClubPlanModalStatus,
  setScoutModalStatus,
  setViewScoutModalStatus,
  setResendEmailModalStatus,
  setSendMessageModalStatus
} = sharedSlice.actions;